import './_fitment-config.scss';

const API_ENDPOINT = 'https://fitmentapi.azurewebsites.net/api/serenity-ymm-staging';
const FITMENT_SHOP_BUTTON = document.querySelector('.fitment_shop_btn');
const FITMENT_CLEAR_BUTTON = document.querySelector('.fitment_clear_btn');

let vehicleTypes;
let currentSelectedVehicle = localStorage.getItem('fitment') ? JSON.parse(localStorage.getItem('fitment')) : {};
let sectionVehicleType;
let currentCollection = null;

async function processFitments(currentSelectedVehicle) {
    let param = '';

    for (const [k, v] of Object.entries(currentSelectedVehicle)) {
        const data = await getFitments(param);

        if (!data || !data.result) {
            console.error('[processFitments] No data or no result property');
            continue;
        }

        const resultKey = Object.keys(data.result)[0];

        if (resultKey && resultKey !== 'sku' && Array.isArray(data.result[resultKey])) {
            makeFitmentSelect(resultKey, data.result[resultKey], v);
        } else {
            console.warn(`[processFitments] Skipping select for key "${resultKey}"`);
        }
        param += '&' + k + '=' + v;
    }

    if (currentCollection) {
        const validateParam = Object.entries(currentSelectedVehicle).map(([k, v]) => `${k}=${v}`).join('&');
        const validation = await getFitments(validateParam);

        if (!validation || !validation.result || Object.keys(validation.result).length === 0) {
            console.warn('[processFitments] Fitment invalid for collection, clearing and reloading');
            localStorage.removeItem('fitment');
            localStorage.removeItem('current_fitment');
            window.location.reload();
            return;
        }
    }

    FITMENT_SHOP_BUTTON.removeAttribute('disabled');

    if (Object.keys(currentSelectedVehicle).length) {
        FITMENT_CLEAR_BUTTON.style.display = 'block';
    }
}

async function getFitments(param) {
    let json;
    document.getElementById('fitment-btn-text').style.display = 'none';
    document.getElementById('fitment-loading').classList.add('fitment-loading--active');

    const collectionParam = currentCollection ? `&current_collection=${currentCollection}` : '';
    const url = `${API_ENDPOINT}?vehicle_type=${sectionVehicleType.name}${collectionParam}${param.length ? `&${param}` : ''}`;

    try {
        const response = await fetch(url);
        json = await response.json();
    } catch (error) {
        console.error('[getFitments] Fetch error:', error);
        document.getElementById('fitment-loading').classList.remove('fitment-loading--active');
        document.getElementById('fitment-error').classList.add('fitment-error--active');
        document.getElementById('fitment-btn-text').style.display = 'block';
    }

    if (json) {
        document.getElementById('fitment-loading').classList.remove('fitment-loading--active');
        document.getElementById('fitment-btn-text').style.display = 'block';
        return json;
    }
}

function removeDuplicates(arr) {
    const uniqueLowercaseValues = [];
    const filteredArray = [];

    arr.forEach((item) => {
        const lowercaseItem = item.toString().toUpperCase();

        if (!uniqueLowercaseValues.includes(lowercaseItem)) {
            uniqueLowercaseValues.push(lowercaseItem);
            filteredArray.push(item);
        }
    });

    return filteredArray;
}

function makeFitmentSelect(id, optionArray, v) {

    if (id === 'year') {
        optionArray = optionArray.reverse();
    }

    const filteredOptions = removeDuplicates(optionArray);

    if (filteredOptions.length > 0) {
        const selectElement = document.getElementById(id);

        if (!selectElement && (id === 'year' || id === 'make' || id === 'model')) {
            console.error(`[makeFitmentSelect] CRITICAL: No <select id="${id}"> in DOM`);
            return;
        }

        if (id === 'year' || id === 'make' || id === 'model') {
            let html = '';
            filteredOptions.forEach(option => {
                if (id === 'year') {
                    html += '<option class="fitment_option" ' + (option == parseInt(v) ? 'selected' : '') + '>' + option + '</option>';
                } else {
                    html += '<option class="fitment_option" ' + (option === v ? 'selected' : '') + '>' + option + '</option>';
                }
            });
            selectElement.innerHTML += html;
            selectElement.removeAttribute('disabled');
        } else {
            let html = '<select id="' + id + '" class="fitment_select select__select">' +
                '<option selected hidden>' + (id === 'drive_type' ? 'Drive Type' : (id === 'fuel_type' ? 'Fuel Type' : id.charAt(0).toUpperCase() + id.slice(1))) + '</option>';
            filteredOptions.forEach(option => {
                html += '<option class="fitment_option" ' + (option === v ? 'selected' : '') + '>' + option + '</option>';
            });
            html += '</select>';
            const container = document.querySelector('.fitment-select__container');
            container.insertAdjacentHTML('beforeend', html);
        }
    } else {
        console.warn(`[makeFitmentSelect] No options to render for "${id}"`);
    }
}

function makeFitmentParam(type) {
    let param = '';
    let isAdding = true;
    let keyArray = [];

    for (let k in currentSelectedVehicle) {
        let v = currentSelectedVehicle[k];
        if (isAdding) {
            param += k + '=' + v + '&';
            keyArray.push(k);
        } else {
            delete currentSelectedVehicle[k];
        }
        if (k == type) {
            isAdding = false;
        }
    }

    document.querySelectorAll('.fitment_select').forEach(element => {
        if (!keyArray.includes(element.id)) {
            let id = element.id;

            if (id === 'year' || id === 'make' || id === 'model') {
                let options = document.querySelectorAll('#' + id + ' option.fitment_option');
                options.forEach(option => {
                    option.remove();
                });

                element.disabled = true;
            } else {
                element.remove();
            }
        }
    });

    return param.slice(0, -1);
}

document.addEventListener('change', function(event) {
    const target = event.target;
    const validSelectArr = ['vehicle_type', 'year', 'make', 'model', 'submodel', 'drive_type', 'fuel_type', 'doors', 'type', 'position'];

    if (target.classList.contains('fitment_select') && validSelectArr.includes(target.id)) {
        currentSelectedVehicle[target.id] = target.value;

        getFitments(makeFitmentParam(target.id)).then(data => {
            const resultKey = Object.keys(data.result)[0];
            if (resultKey && resultKey !== 'sku' && Array.isArray(data.result[resultKey]) && data.result[resultKey].length > 0) {
                makeFitmentSelect(resultKey, data.result[resultKey]);
                FITMENT_SHOP_BUTTON.setAttribute('disabled', '');
            } else {
                FITMENT_SHOP_BUTTON.removeAttribute('disabled');
            }
        });
    }
});


if (FITMENT_SHOP_BUTTON) {
    FITMENT_SHOP_BUTTON.addEventListener('click', function() {
        window.dispatchEvent(new CustomEvent("fitmentChanged", { detail: currentSelectedVehicle }));
        localStorage.setItem('fitment', JSON.stringify(currentSelectedVehicle));
        localStorage.setItem('current_fitment', sectionVehicleType.name);

        if (!document.URL.includes('/collections/') && !document.URL.includes('/products/') && !document.URL.includes('search?q=')) {
            window.location.href = sectionVehicleType.route;
        } else if (document.URL.includes('collections') || document.URL.includes('search?q=')) {
            const baseUrl = window.location.origin + window.location.pathname
            window.history.replaceState({}, document.title, baseUrl);
            window.location.href = baseUrl;
        }
    });
}

if (FITMENT_CLEAR_BUTTON) {
    FITMENT_CLEAR_BUTTON.addEventListener('click', function () {
        currentSelectedVehicle = {};
        localStorage.removeItem('fitment');

        document.querySelectorAll('.fitment_select').forEach(element => {
            let id = element.id;

            if (id === 'year' || id === 'make' || id === 'model') {
                element.querySelectorAll('option.fitment_option').forEach(option => {
                    option.remove();
                });

                element.disabled = true;
            } else {
                element.remove();
            }
        });

        getFitments('').then((data) => {
            if (data && data.result && Array.isArray(data.result.year) && data.result.year.length > 0) {
                makeFitmentSelect('year', data.result.year);
            }
        });
        FITMENT_SHOP_BUTTON.setAttribute('disabled', '');
        FITMENT_CLEAR_BUTTON.style.display = 'none';

        window.location.reload();
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const fitmentConfigSection = document.querySelector('.fitment-config');

    if (fitmentConfigSection) {
        const vehicleTypeString = fitmentConfigSection.dataset.fitmentCollections;

        vehicleTypes = vehicleTypeString.split(';').map((type) => {
            type = type.split('|');

            return {
                name: type[0],
                handle: type[1],
                route: `/collections/${type[1]}`,
            };
        });

        sectionVehicleType = vehicleTypes.find((vt) => {
            return vt.name.toLowerCase() === fitmentConfigSection.dataset.vehicleType.toLowerCase() && vt.handle === fitmentConfigSection.dataset.selectedCollectionHandle;
        });

        const path = window.location.pathname;
        if (path.includes('/pages/truck-uca') || path.includes('/collections/upper-control-arms')) {
            currentCollection = 'uca';
        }

        if (Object.keys(currentSelectedVehicle).length && sectionVehicleType.name === localStorage.getItem('current_fitment')) {
            processFitments(currentSelectedVehicle);
        } else {
            localStorage.removeItem('fitment');
            localStorage.removeItem('current_fitment');

            getFitments('').then((data) => {
                if (data && data.result && Array.isArray(data.result.year) && data.result.year.length > 0) {
                    makeFitmentSelect('year', data.result.year);
                } else {
                    console.error('[DOMContentLoaded] No valid year data in response. data:', JSON.stringify(data));
                }
            });
        }
    }
});
